import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import type { PopupData, Service, ValidationErrors } from 'webapp-types';
import { validateByRules } from 'webapp/utils/validate';

import FormTextareaComponent from 'webapp/components/form/textarea';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import RowErrorComponent from 'webapp/components/row-error';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class SourcePopupRequestComponent extends PopupInnerModalComponent<PopupData.Source.Request> {
	@service('infolayer') declare infolayerService: Service.Infolayer;
	@service('request') declare requestService: Service.Request;

	@tracked errors: ValidationErrors<string> = {};
	@tracked metrics = '';

	get sourceType() {
		return this.popupData.sourceType;
	}

	validateForm() {
		const errors = validateByRules(this, ['required'], 'metrics');
		this.errors = errors;
		return Object.keys(errors).length === 0;
	}

	@action
	save() {
		if (this.submitInProgress || !this.validateForm()) {
			return;
		}

		this.submitInProgress = true;

		const data = {
			key: this.sourceType.key,
			metrics: this.metrics,
		};
		this.requestService
			.api('POST', '/request-connector', data)
			.then(() => {
				this.infolayerService.ok('Thanks for helping us out!');
				this.close();
			})
			.finally(() => {
				this.submitInProgress = false;
			})
			.catch(this.requestService.showAllValidationErrors.bind(this.requestService));
	}
	<template>
		<div class="title">
			<img src={{this.sourceType.avatar}} alt={{this.sourceType.name}} />
			Activate
			{{this.sourceType.name}}
		</div>
		<div class="content">

			<p>
				<strong>
					This data source is not yet available but we're working hard to add it to one of
					our future updates.
				</strong>
			</p>

			<p>
				Let us know which metrics you would like to see integrated and we'll do our best to
				make them available soon.
			</p>

			<div class="row">
				<FormTextareaComponent
					name="metrics"
					@value={{this.metrics}}
					placeholder="Write your suggestions here"
					disabled={{this.submitInProgress}}
				/>
				<RowErrorComponent @items={{this.errors.metrics}} />
			</div>

			<SubmitButtonComponent
				@text="Submit"
				@extraClass="save"
				@onTrigger={{this.save}}
				@submitInProgress={{this.submitInProgress}}
			/>

			<p>
				If you are more technical, you can use our
				<a href="https://developers.databox.com" target="_blank">developer tools</a>
				to build a connector by yourself.
			</p>

		</div>
	</template>
}
